module.exports = __webpack_public_path__ + "static/media/3560.29eef7b7.jpg";